import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function DecentralizedCreative() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
      {/* Navigation */}
      <nav style={{
        backgroundColor: '#000000',
        padding: '1rem 2rem',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        borderBottom: '1px solid #333'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <img src={process.env.PUBLIC_URL + '/avatar.png'} alt="Avatar" style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }} />
            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: '#fff' }}>Decentralized Creative</h2>
          </div>

          {/* Desktop Menu */}
          <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
            <a href="#home" style={{ textDecoration: 'none', color: '#fff', cursor: 'pointer', fontSize: '14px' }}>Home</a>
            <a href="#services" style={{ textDecoration: 'none', color: '#fff', cursor: 'pointer', fontSize: '14px' }}>Services</a>
            <a href="#contact" style={{ textDecoration: 'none', color: '#fff', cursor: 'pointer', fontSize: '14px' }}>Contact</a>
            <a href="#blog" style={{ textDecoration: 'none', color: '#fff', cursor: 'pointer', fontSize: '14px' }}>Blog</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #FFC107 0%, #FFC107 100%)',
        padding: '4rem 2rem',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          maxWidth: '1000px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 2
        }}>
          <div style={{
            display: 'inline-block',
            backgroundColor: '#FF1744',
            color: '#fff',
            padding: '0.5rem 1.5rem',
            borderRadius: '50px',
            fontSize: '12px',
            fontWeight: 600,
            marginBottom: '2rem',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            Innovative Creative Solutions
          </div>

          <h1 style={{
            fontSize: '48px',
            fontWeight: 700,
            color: '#fff',
            marginBottom: '2rem',
            lineHeight: '1.2'
          }}>
            Helping creative entrepreneurs like you embrace decentralized tech.
          </h1>

          <p style={{
            fontSize: '16px',
            color: '#fff',
            maxWidth: '700px',
            margin: '0 auto 2rem',
            lineHeight: '1.6'
          }}>
            At Decentralized Creative, we help you harness blockchain technology to elevate your digital presence and faster growth in the creative industry.
          </p>

          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginBottom: '1rem'
          }}>
            <span style={{ fontSize: '14px', color: '#fff', fontWeight: 500 }}>⭐⭐⭐⭐⭐</span>
            <span style={{ fontSize: '14px', color: '#fff' }}>54 real people say about us</span>
          </div>
        </div>
      </section>

      {/* Crypto Section */}
      <section style={{
        backgroundColor: '#000000',
        padding: '4rem 2rem',
        color: '#fff'
      }}>
        <div style={{
          maxWidth: '1000px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: '36px',
            fontWeight: 700,
            marginBottom: '1.5rem',
            lineHeight: '1.3'
          }}>
            Getting started in crypto can be daunting! Let me help you understand how to start accepting, saving and spending cryptocurrency.
          </h2>

          <button style={{
            backgroundColor: '#FF1744',
            color: '#fff',
            border: 'none',
            padding: '0.75rem 2rem',
            borderRadius: '50px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
            marginTop: '1rem'
          }}>
            Schedule a consultation with me and get started in crypto today
          </button>
        </div>
      </section>

      {/* Services Section */}
      <section style={{
        padding: '4rem 2rem',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <h2 style={{
          fontSize: '32px',
          fontWeight: 700,
          marginBottom: '3rem',
          textAlign: 'center',
          color: '#000'
        }}>
          Need some creative work done? I got you
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '2rem'
        }}>
          {[
            { title: 'Explainer Videos', emoji: '🎬' },
            { title: 'Promo Videos', emoji: '📺' },
            { title: 'Podcast Editing', emoji: '🎙️' },
            { title: 'Crypto Consultation', emoji: '🔐' }
          ].map((service, i) => (
            <div key={i} style={{
              backgroundColor: '#f5f5f5',
              padding: '2rem',
              borderRadius: '12px',
              border: '1px solid #e0e0e0',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '1rem' }}>
                {service.emoji}
              </div>
              <h3 style={{
                fontSize: '18px',
                fontWeight: 600,
                color: '#000',
                marginBottom: '0.5rem'
              }}>
                {service.title}
              </h3>
              <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                [Service description coming soon]
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Portfolio Section */}
      <section style={{ padding: '4rem 2rem', backgroundColor: '#f9f9f9' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: '28px',
            fontWeight: 700,
            marginBottom: '3rem',
            textAlign: 'center',
            color: '#000'
          }}>
            Recent Work
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
            {[1, 2, 3].map(i => (
              <div key={i} style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                overflow: 'hidden',
                border: '1px solid #e0e0e0'
              }}>
                <div style={{
                  height: '200px',
                  backgroundColor: '#ddd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#999'
                }}>
                  [Portfolio item {i}]
                </div>
                <div style={{ padding: '1.5rem' }}>
                  <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#000', marginBottom: '0.5rem' }}>
                    Project Title
                  </h3>
                  <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                    [Project description coming soon]
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        backgroundColor: '#000000',
        color: '#fff',
        padding: '3rem 2rem',
        borderTop: '1px solid #333'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '2rem',
            marginBottom: '2rem'
          }}>
            <div>
              <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '1rem' }}>Navigation</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}><a href="#" style={{ color: '#999', textDecoration: 'none', fontSize: '14px' }}>Home</a></li>
                <li style={{ marginBottom: '0.5rem' }}><a href="#" style={{ color: '#999', textDecoration: 'none', fontSize: '14px' }}>Services</a></li>
                <li style={{ marginBottom: '0.5rem' }}><a href="#" style={{ color: '#999', textDecoration: 'none', fontSize: '14px' }}>Contact</a></li>
                <li style={{ marginBottom: '0.5rem' }}><a href="#" style={{ color: '#999', textDecoration: 'none', fontSize: '14px' }}>Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '1rem' }}>Connect</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}><a href="#" style={{ color: '#999', textDecoration: 'none', fontSize: '14px' }}>Twitter</a></li>
                <li style={{ marginBottom: '0.5rem' }}><a href="#" style={{ color: '#999', textDecoration: 'none', fontSize: '14px' }}>LinkedIn</a></li>
                <li style={{ marginBottom: '0.5rem' }}><a href="#" style={{ color: '#999', textDecoration: 'none', fontSize: '14px' }}>Discord</a></li>
              </ul>
            </div>
          </div>

          <div style={{
            borderTop: '1px solid #333',
            paddingTop: '1.5rem',
            textAlign: 'center',
            color: '#666',
            fontSize: '14px'
          }}>
            <p>© 2026 Decentralized Creative. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}